import { Box, type BoxProps } from "@mui/material";
import { mergeSxProps } from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings } from "@src/appV2/redesign/system/ui-theme";

interface PageFooterWrapperProps extends BoxProps {
  withShadow?: boolean;
}

export function PageFooterWrapper(props: PageFooterWrapperProps) {
  const { sx, withShadow = false, ...restProps } = props;

  return (
    <Box
      {...restProps}
      sx={mergeSxProps(
        (theme) => ({
          marginTop: "auto",
          paddingX: 5,
          paddingTop: 5,
          flexShrink: 0,
          boxShadow: withShadow ? theme.shadows[4] : "none",
          ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(5) }),
        }),
        sx
      )}
    />
  );
}
